import React, { forwardRef } from 'react';
import * as styles from './NewPostSelectOption.module.scss';
import BorderedIcon from '../components/BorderedIcon';
import SelectEntityOption from '../components/SelectEntityOption';
import addIcon from '../icons/non-prefilled/16x16/add.svg';

interface NewPostSelectOptionProps {
  title: string;
}

const NewPostSelectOption = forwardRef<
  HTMLDivElement,
  NewPostSelectOptionProps
>(({ title }, ref) => (
  <SelectEntityOption
    icon={
      <div className={styles.icon}>
        <BorderedIcon>{addIcon}</BorderedIcon>
      </div>
    }
    label={title}
    secondary="Create new post"
    ref={ref}
  />
));

export default NewPostSelectOption;
